var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-block"},[_vm._t("header",function(){return [_c('p',{staticClass:"h3 font-weight-bold p-0 my-2"},[_vm._v(_vm._s(_vm.titlePage))])]}),(_vm.useAlertSystem && _vm.alert.show)?_c('base-alert-system',{attrs:{"message":_vm.alert.message,"error":_vm.alert.error},on:{"hide-alert":() => {
        _vm.alert.show = false;
      }}}):_vm._e(),_vm._t("default",function(){return [_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }